"use strict";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var flatten = require('lodash/flatten');

var Component = require('./Component');
/**
 * A collection of a particular type of component
 * @interface ComponentCollection
 * @param {Array<Component>} collection - component instance(s)
 * @param {Component} Constructor - component prototype
 * @property {String} type
 * @property {Number} length
 * @property {Array<String>} versions
 * @property {Array<String>} quantities
 * @property {Number} quantity
 */


var ComponentCollection = /*#__PURE__*/function () {
  function ComponentCollection() {
    var collection = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var Constructor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Component;

    _classCallCheck(this, ComponentCollection);

    // create a new collection, or rebuild a collection
    if (Array.isArray(collection)) {
      this.collection = collection.map(function (c) {
        return new Constructor(c);
      });
    } else if (collection instanceof ComponentCollection || Array.isArray(collection.collection)) {
      this.collection = collection.collection.map(function (c) {
        return new Constructor(c);
      });
    } else {
      this.collection = [new Constructor(collection)];
    }

    this.Constructor = Constructor;
    this.version = this.version.bind(this);
    this.add = this.add.bind(this);
    this.remove = this.remove.bind(this);
    this.duplicate = this.duplicate.bind(this);
    this.first = this.first.bind(this);
    this.last = this.last.bind(this);
    this.at = this.at.bind(this);
    this.resetVersions = this.resetVersions.bind(this);
    this.resetVersions();
  }

  _createClass(ComponentCollection, [{
    key: "type",
    get: function get() {
      var Constructor = this.Constructor;
      var instance = new Constructor({});
      return instance.name;
    }
  }, {
    key: "length",
    get: function get() {
      return this.collection.length;
    }
  }, {
    key: "versions",
    get: function get() {
      this.resetVersions();
      return this.collection.map(function (component) {
        return component.version;
      });
    }
  }, {
    key: "quantities",
    get: function get() {
      return this.collection.map(function (component) {
        return parseInt(component.quantity, 10);
      });
    }
  }, {
    key: "quantity",
    get: function get() {
      return this.collection.map(function (component) {
        return parseInt(component.quantity, 10);
      }).reduce(function (p, v) {
        return p + v;
      }, 0);
    }
  }, {
    key: "components",
    get: function get() {
      return this.collection;
    }
    /**
      * gets component with version <ver>
      * @param {String} version
      * @returns {Component} Component
      */
    ,
    set: function set(params) {
      var _this = this;

      var collection = JSON.parse(JSON.stringify(params));

      if (Array.isArray(collection)) {
        this.collection = collection.map(function (c) {
          return new _this.Constructor(c);
        });
      } else if (collection instanceof ComponentCollection || Array.isArray(collection.collection)) {
        this.collection = collection.collection.map(function (c) {
          return new _this.Constructor(c);
        });
      } else {
        this.collection = [new this.Constructor(collection)];
      }
    }
  }, {
    key: "version",
    value: function version(ver) {
      this.resetVersions();

      if (ver && !ver.match(/[A-Z]/)) {
        throw new Error('version must be a capital letter between A and Z');
      }

      if (this.collection.length === 0) {
        // todo: make this run .add() instead of erroring...
        // throw new Error(`${this.type} had no version ${ver}`);
        return this.add(); // or should it return undefined?
        // return undefined;
      }

      if (this.collection.length === 1 || !ver) {
        return this.collection[0];
      }

      var component = this.collection.filter(function (c) {
        return c.version === ver;
      });

      if (component.length > 1) {
        throw new Error("Found two components with version ".concat(ver, ". Something is very wrong."));
      }

      return component[0];
    }
    /**
       * return the first component
       * @returns {Component} Component
       */

  }, {
    key: "first",
    value: function first() {
      this.resetVersions();
      return this.version('A');
    }
    /**
       * return the last component
       * @returns {Component} Component
       */

  }, {
    key: "last",
    value: function last() {
      this.resetVersions();
      return this.at(this.collection.length - 1);
    }
    /**
       * get component n
       * @param {Number} n
       * @returns {Component} Component
       */

  }, {
    key: "at",
    value: function at(n) {
      if (!Number.isInteger(n)) {
        throw new Error('at() expects an integer between 0 and 25');
      }

      return this.version(String.fromCharCode(n + 65));
    }
    /**
      * add a component to a set and set the versions
      * @param {Object} params
      * @returns {Component} Component
      */

  }, {
    key: "add",
    value: function add() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.collection.push(new this.Constructor(params));
      this.resetVersions();
      return this.last();
    }
    /**
       * after changing the array, resetVersions() will set the version field of each component
       */

  }, {
    key: "resetVersions",
    value: function resetVersions() {
      var _this2 = this;

      if (this.collection.length > 1) {
        this.collection.forEach(function (c, i) {
          _this2.collection[i].version = String.fromCharCode(i + 65);
        });
      }

      if (this.collection.length === 1) {
        this.collection[0].version = '';
      }
    }
    /**
       * @returns {Array<Component>} Component[]
       */

  }, {
    key: "all",
    value: function all() {
      this.resetVersions();
      return this.collection;
    }
    /**
       * @returns {Array<Component>} Component[]
       */

  }, {
    key: "subcomponents",
    value: function subcomponents() {
      this.resetVersions();
      return flatten(this.collection.map(function (component) {
        return component.subcomponents;
      }));
    }
    /**
      * Removes a version of a component
      * @param {string} version - The version to remove
      */

  }, {
    key: "remove",
    value: function remove(version) {
      if (version && !version.match(/[A-Z]/)) {
        throw new Error('version must be a capital letter between A and Z');
      }

      if (version) {
        // remove a specific one
        var indexToRemove = this.collection.map(function (c) {
          return c.version;
        }).indexOf(version);
        this.collection.splice(indexToRemove, 1);
      } else {
        // remove the last one
        this.collection.pop();
      }

      this.resetVersions();
    }
    /**
       * Clears all instances of a component collection
       */

  }, {
    key: "clear",
    value: function clear() {
      this.collection = [];
    }
    /**
       *
       * @param {string} version
       */

  }, {
    key: "duplicate",
    value: function duplicate() {
      var version = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'A';
      var component = this.version(version);
      this.add(_objectSpread({}, component));
      this.resetVersions();
    }
    /**
       * @alias duplicate
       */

  }, {
    key: "split",
    value: function split() {
      var version = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'A';
      this.duplicate(version);
    }
  }]);

  return ComponentCollection;
}();

module.exports = ComponentCollection;